<template>
  <section class="form-creator">
    <div class="header add--text-align-center">
      <h2 class="header__primary">Form inputs</h2>
    </div>

    <div class="form-field-list">
      <draggable
        v-model="form.inputs"
        @start="drag = true"
        @end="drag = false"
      >
        <div
          class="form-field"
          v-for="(input, inputIndex) in form.inputs"
          :key="inputIndex"
        >
          <div class="form-field-input-number">
            INPUT {{inputIndex + 1}}: 
          </div>
          <div class="form-field-input">
            <div
              class="form-field-input-title"
              v-if="
                editingLanguage == $settingsSecondLanguageType &&
                !$isSingleLanguage
              "
            >
              {{ input.labels[1] }}
            </div>
            <div class="form-field-input-title" v-else>{{ input.labels[0] }}</div>
            <div class="form-field-input-type">
              TYPE - {{ input.type }}
            </div>
            <div class="form-field-input-required">
                {{ input.isRequired ? 'REQUIRED' : 'NOT REQUIRED' }}
            </div>
          </div>
          <div
            class="form-input-remove"
            @click="removeInput(inputIndex)"
          >
            <v-icon name="times-circle" style="align-self: center"></v-icon>
          </div>
        </div>
      </draggable>
      <div class="add-item" v-if="currentInputIndex == form.inputs.length">
        <div class="row">
          <input
            class="add-item__label"
            :style="{
              border: isInputEmpty
                ? '2px solid #D95D5D'
                : '1px solid #AAAAAA',
            }"
            @input="
              (e) => {
                inputLabel = e.target.value;
              }
            "
            :value="inputLabel"
            :placeholder="placeholderPrimary"
            :maxlength="itemMaxLength"
          />
          <div class="add-item__required">
            <GlobalInputSwitch
              label="REQUIRED?"
              v-model="isRequired"
            />
          </div>
        </div>
        <div class="row">
          <input
            class="add-item__label"
            :style="{
              opacity: !$isSingleLanguage ? 1 : 0.5,
              border:
                isSecondaryInputEmpty && !$isSingleLanguage
                  ? '2px solid #D95D5D'
                  : '1px solid #AAAAAA',
            }"
            :disabled="$isSingleLanguage"
            @input="
              (e) => {
                inputLabelSec = e.target.value;
              }
            "
            :value="inputLabelSec"
            :placeholder="placeholderSecondary"
            :maxlength="itemMaxLength"
          />
          <div class="add-item__type">
            <select 
              v-model="inputType"
              :style="{
                border: isTypeEmpty
                  ? '2px solid #D95D5D'
                  : '1px solid #AAAAAA',
              }">
                <option value="" disabled>Input type</option>
                <option
                  v-for="(option, index) in inputTypes"
                  :key="index"
                  :value="option"
                >
                  {{ option }}
                </option>
            </select>
          </div>
          <div
            class="add-item__add-button"
            :style="{ color: '#FFFFFF', backgroundColor: '#48b9ba' }"
            @click="saveField(inputLabel, inputLabelSec, inputType, isRequired)"
          >
            SAVE FIELD
          </div>
        </div>
      </div>
      
      <div
        class="form-input-add"
        :style="{ backgroundColor: '#48b9ba' }"
        @click="addInput"
      >
        <p class="form-input-add__text" :style="{ color: '#FFFFFF' }">
          ADD INPUT
        </p>
        <v-icon
          class="form-input-add__icon"
          name="plus-circle"
          scale="1.3"
        ></v-icon>
      </div>
    </div>
  </section>
</template>

<script>
import draggable from "vuedraggable";
import GlobalInputSwitch from "@/components/GlobalComponents/GlobalInputSwitch";
import { db } from "@/firebase";

export default {
  components: {
    draggable,
    GlobalInputSwitch
  },
  props: {
    existingForm: [Array, Object],
    editingLanguage: String,
  },
  data() {
    return {
      form: {},
      inputTypes: ['EMAIL', 'PHONE', 'TEXTFIELD'],
      inputType: "",
      inputLabel: "",
      inputLabelSec: "",
      isRequired: false,
      currentInputIndex: -1,
      itemMaxLength: 30,
      isInputEmpty: false,
      isSecondaryInputEmpty: false,
      isTypeEmpty: false,
      localLanguageTypesIndex: 0
    };
  },
  created() {
    if (this.existingForm) {
      this.form = this.existingForm;
    }
    if(!this.form.inputs || this.form.inputs[0].labels[0] == ""){
      this.form.inputs = [];
    }
    db.ref(`users/${this.$userId}/languageTypesIndex`).on("value", (data) => {
      this.localLanguageTypesIndex = data.val();
    });
  },
  computed: {
    placeholderPrimary() {
      let placeholderText = "Insert input name";
      if (!this.$isSingleLanguage) {
        placeholderText += ` (${this.$settingsDefaultLanguageType})`;
      }
      return placeholderText;
    },
    placeholderSecondary() {
      let placeholderText = "Insert input name";
      if (!this.$isSingleLanguage) {
        placeholderText += ` (${this.$settingsSecondLanguageType})`;
      } else {
        placeholderText = "Only one language enabled";
      }
      return placeholderText;
    },
  },
  watch: {
    form: {
      handler: function (newValue) {
        this.$emit("updateForm", newValue);
      },
      deep: true,
    },
  },
  mounted: function () {
    document.addEventListener("keydown", this.handleKeydown);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    addInput() {
      if(this.currentInputIndex != -1) {
        return;
      }
      this.currentInputIndex = this.form.inputs.length;
      this.inputType = '';
      this.isInputEmpty = false;
      this.isSecondaryInputEmpty = false;
      this.inputLabel = '';
      this.inputLabelSec = '';
      this.isRequired = false;
      this.isTypeEmpty = false;
    },
    handleKeydown(e) {
      if (
        e.keyCode == 13 &&
        this.inputLabel.length > 0
      ) {
        this.saveField(this.inputLabel, this.inputLabelSec, this.inputType, this.isRequired);
      }
    },
    saveField(inputLabel, inputLabelSec, type, isRequired) {
      if (!this.$isSingleLanguage) {
        if (inputLabel.length > 0 && inputLabelSec.length > 0 && type.length > 0) {
          this.form.inputs[this.currentInputIndex] = {
            type: type,
            isRequired: isRequired,
            labels: [
              inputLabel,
              inputLabelSec
            ]
          };
        } else {
          this.isInputEmpty = inputLabel.length == 0 ? true : false;
          this.isSecondaryInputEmpty = inputLabelSec.length == 0 ? true : false;
          this.isTypeEmpty = type.length === 0 ? true : false;
          return;
        }
        this.isInputEmpty = false;
        this.isSecondaryInputEmpty = false;
        this.isTypeEmpty = false;
      } else {
        if (inputLabel.length > 0 && type.length > 0) {
          this.form.inputs[this.currentInputIndex] = {
            type: type,
            isRequired: isRequired,
            labels: [
              inputLabel
            ]
          };
        } else {
          this.isInputEmpty = inputLabel.length == 0 ? true : false;
          this.isTypeEmpty = type.length === 0 ? true : false;
          return;
        }
        this.isInputEmpty = false;
        this.isTypeEmpty = false;
      }
      this.currentInputIndex = -1;
    },
    removeInput(inputIndex) {
      this.form.inputs.splice(inputIndex, 1);
    },
    charactersRemaining(string) {
      return string ? string.length : 0;
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
}

.header {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.header__primary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 30px !important;
  font-weight: 400;
  color: black;
}

/*
  Add item
*/

.add-item {
  font-size: 16px;
  cursor: initial;
}

.row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 5px 0;
}

.add-item__label {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #aaaaaa;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
  outline: none;
  height: 40px;
  width: 50%;
  margin-right: 10px;
}

.add-item__type {
  width: 25%;
  margin-right: 10px;
}
.add-item__type select{
  text-align: center;
  border: 1px solid #aaaaaa;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
  outline: none;
  width: 100%;
  height: 40px;
}

.add-item__price::placeholder,
.add-item__title::placeholder {
  text-align: center;
}

.add-item__add-button {
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
  outline: none;
  width: 20%;
  cursor: pointer;
  height: 40px;
}

/* To prevent vertical scrollings of the inputs - TODO fix properly */
input {
  line-height: 100%;
}

.form-creator {
  padding: 5px 50px;
  margin-bottom: 25px;
  height: 100%;
  overflow: auto;
  border: 2px solid #aaaaaa;
  border-radius: 8px;
  background-color: #ffffff;
}

.form-creator input:focus::placeholder {
  color: transparent;
}

.form-field {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  border-radius: 8px;
  margin-bottom: 15px;
  cursor: move;
  position: relative;
}

.form-field-input {
  display: flex;
  width: 100%;
  padding: 5px;
}

.form-field-input-title {
  width: 40%;
}

.form-field-input-type {
  width: 35%;
}

.form-input-add {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 40px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  margin: 10px 0px;
}

.form-field-input-number {
  width: 100%;
  color: var(--primary);
  color: #48b9ba;
  font-size: 20px;
  margin-bottom: 10px;
}

.form-input-remove {
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 40px;
  height: 20px;
  position: absolute;
  left: -40px;
  top: 1px;
}

.form-input-add__icon {
  margin-left: 5px;
}

</style>
